/**
 * Workspace slugs that must not be assignable to a workspace because they
 * collide with real application routes, API mounts, or common
 * platform/security-sensitive names (e.g. a workspace at `/admin` would
 * shadow the admin route). Dependency-free by design so both apps/web
 * (client-side slug validation) and packages/api (server-side enforcement)
 * can import it without pulling in unrelated code.
 */
export const RESERVED_WORKSPACE_SLUGS: ReadonlySet<string> = new Set([
  // Top-level app routes (apps/web/src/routes)
  'accept-invite',
  'admin',
  'getting-started',
  'forgot-password',
  'login',
  'reset-password',
  'signup',
  'privacy',
  'terms',

  // Top-level Hono API mounts (apps/web/src/api/index.ts)
  'api',
  'trpc',
  'slingshot',
  'screenshots',

  // Common reserved / security-sensitive names
  'app',
  'auth',
  'logout',
  'signin',
  'sign-in',
  'sign-up',
  'register',
  'settings',
  'account',
  'billing',
  'docs',
  'blog',
  'help',
  'support',
  'status',
  'www',
  'mail',
  'root',
  'system',
  'internal',
  'static',
  'assets',
  'public',
  'new',
  'create',
  'invite',
  'join',
  'onboarding',
  'workspace',
  'workspaces',
  'user',
  'users',
  'team',
  'teams',
  'dashboard',
  'home',
  'about',
  'pricing',
  'legal',
  'security',
  'trevize',
])

/** Slugs are stored/compared lowercase; guard against callers that haven't normalized yet. */
export const isReservedWorkspaceSlug = (slug: string): boolean =>
  RESERVED_WORKSPACE_SLUGS.has(slug.toLowerCase())
